import Phaser from 'phaser';

export enum Moves {
	None = -1,
	Left = Phaser.Input.Keyboard.KeyCodes.LEFT,
	Right = Phaser.Input.Keyboard.KeyCodes.RIGHT,
	Up = Phaser.Input.Keyboard.KeyCodes.UP,
	Down = Phaser.Input.Keyboard.KeyCodes.DOWN
}

export const MovesList = [
	Moves.Up,
	Moves.Down,
	Moves.Left,
	Moves.Right
];

export const MoveMap = {
	[Moves.Left]: Phaser.Math.Vector2.LEFT,
	[Moves.Right]: Phaser.Math.Vector2.RIGHT,
	[Moves.Up]: Phaser.Math.Vector2.UP,
	[Moves.Down]: Phaser.Math.Vector2.DOWN,
	[Moves.None]: Phaser.Math.Vector2.ZERO
};

export const PerpMap = {
	[Moves.Left]: [Moves.Up, Moves.Down],
	[Moves.Right]: [Moves.Down, Moves.Up],
	[Moves.Up]: [Moves.Right, Moves.Left],
	[Moves.Down]: [Moves.Left, Moves.Right],
	[Moves.None]: []
};

export const debugMoves = {
	[Moves.Left]: 'LEFT',
	[Moves.Right]: 'RIGHT',
	[Moves.Up]: 'UP',
	[Moves.Down]: 'DOWN',
	[Moves.None]: 'NONE'
};